import { RequestMethod } from "utils/useApiClient";

export interface ModuleInterface {
    name: string;
    label: string;
    type: ModuleTypes;
    endpoint?: string;
    valueKey?: string;
    labelKey?: string;
    layout?: { labelCol?: object; wrapperCol?: object };
    isEnum?: boolean;
    method?: RequestMethod;
    filters?: Record<string, string | number | boolean | (string | number | boolean)[]>;
    searchKey?: string;
    translation?: string;
    localeTranslation?: boolean;
    cacheTime?: number;
    required?: boolean;
    /** static select (type: select) — option value => translation key */
    manualOptions?: Record<string, string>;
    mode?: 'multiple' | 'tags';
    /** asyncSelect response shape overrides (defaults: dataKey 'data', array response) */
    dataKey?: string;
    isResponseArray?: boolean;
    integerKey?: boolean;
    /** dateRange: tooltip next to the label */
    hint?: string;
    /** dateRange: the end may be at most this many days (inclusive) after the start */
    maxDays?: number;
}

export enum ModuleTypes {
    input = 'input',
    asyncSelect = 'asyncSelect',
    dateRange = 'dateRange',
    asyncRadio = 'asyncRadio',
    asyncCheckbox = 'asyncCheckbox',
    select = 'select',
    switch = 'switch',
    checkbox = 'checkbox',
}

export enum UserRoleEnum {
    SuperAdmin = 'SUPER_ADMIN',
    Admin = 'ADMIN',
    Student = 'STUDENT',
    CustomerAdmin = 'CUSTOMER_ADMIN',
    Supervision = 'SUPERVISION',
    Lector = 'LECTOR',
}

export enum UserAccountStatusEnum {
    Active = 'ACTIVE',
    Blocked = 'BLOCKED',
}

export enum EntitiesStatusEnum {
    Active = 'ACTIVE',
    Blocked = 'BLOCKED',
}